import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Amenities } from 'src/app/models/interfaces/amenities';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';
import { RutFormat, formatRut } from '@fdograph/rut-utilities';

@Component({
  selector: 'app-add-facility',
  templateUrl: './add-facility.component.html',
  styleUrls: ['./add-facility.component.css']
})
export class AddFacilityComponent  {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }

  @Output()
  success = new EventEmitter<boolean| number>();
  items: any;
  form = new UntypedFormGroup({
    name: new UntypedFormControl(),
    lastname: new UntypedFormControl(),
    owner: new UntypedFormControl(''),
    owner_phone: new UntypedFormControl(''),
    rut: new UntypedFormControl(''),
    turn: new UntypedFormControl(''),
    location: new UntypedFormControl(''),
    email: new UntypedFormControl(''),
    phone: new UntypedFormControl(''),
  });
  form2 = new UntypedFormGroup({
    rooms_id: new UntypedFormControl(0),
    amenities_id: new UntypedFormControl(0),
  });
  addnew: boolean = false;
  amenities: Amenities[];
  @Input()
  refModal:NgbModalRef;
  create() {
    this.api.createFacility(this.form).subscribe(
      (res) => {
        this.toast.success('Creada correctamente', 'Gestión instalaciones');
        let facility=res.data as Facility;
        this.success.emit(facility?.id);
        if(this.refModal!=null){
          this.refModal.close();
        }       
        this.modal.dismissAll(); 
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }
  onFormatRut(value: any) {
    let rut = value.target.value;
    if (rut.length > 8) {
      rut = formatRut(rut, RutFormat.DOTS_DASH)
      this.form
        .get('rut')
        ?.setValue(rut);
    }
  }
}
